// extracted by mini-css-extract-plugin
export var blogListingFooter = "masonry-module--blog-listing-footer--vFJc4";
export var blogListingGrid = "masonry-module--blog-listing-grid--rCjNf";
export var blogListingGrid_column = "masonry-module--blog-listing-grid_column--bUIzF";
export var card = "masonry-module--card--Wd9r-";
export var cardDescription = "masonry-module--card-description--F9BW7";
export var cardTags = "masonry-module--card-tags--XNBdi";
export var cardTitle = "masonry-module--card-title--GoiqO";
export var hasMoreButton = "masonry-module--has-more-button--RXojP";